var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", staticStyle: { position: "relative" } },
    [
      _c("booking-tree-grid", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "list",
            expression: "view==='list'"
          }
        ],
        ref: "bookingTreeGrid",
        attrs: { context: _vm.context, "is-query": _vm.isQuery },
        on: {
          look: _vm.lookHandle,
          edit: _vm.editHandle,
          copy: _vm.copyHandle,
          add: _vm.addHandle
        }
      }),
      _c("booking-workspace", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.view === "detail",
            expression: "view==='detail'"
          }
        ],
        ref: "bookingWorkspace",
        attrs: { "parent-context": _vm.context, view: _vm.view },
        on: {
          edit: _vm.editHandle,
          copy: _vm.copyHandle,
          add: _vm.addHandle,
          back: _vm.backToList
        }
      }),
      _c("air-op-type-dialog", {
        attrs: { visible: _vm.airOpTypeDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.airOpTypeDialog, "visible", $event)
          },
          successHandle: _vm.airOpTypeSuccessHandle,
          cancel: _vm.airOpTypeCancelHandle
        }
      }),
      _c("job-copy-window", {
        attrs: {
          visible: _vm.copyDialog.visible,
          lob: _vm.copyDialog.job.lob || "",
          "is-master": _vm.copyDialog.job.masterFlag
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyDialog, "visible", $event)
          },
          confirmCallBack: _vm.confirmCallBackHandler
        }
      }),
      _c("job-no-rule-selector", {
        attrs: {
          visible: _vm.jobNoRule.visible,
          rules: _vm.jobNoRule.rules || []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.jobNoRule, "visible", $event)
          },
          selectedBack: _vm.doCopyJob
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }